attendeeList.directive('attendeeList', [
    'templateCache',
    'helperService',
    '$timeout',
    function (templateCache, helperService, $timeout) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(
                'attendee_list/templates/' + helperService.getRedesignPathPrefix() + 'attendeeList.html'
            ),
            link: function (scope, element) {
                scope.$on('on-scroll-attendee-list-up', function () {
                    $timeout(function () {
                        $('.attendee-list-container').scrollTop(0);
                    });
                });
            }
        };
    }
]);
